import { Stack, useLocalSearchParams } from 'expo-router';

import { FruitSlicePageBackground } from '../../../../fruit-slices/components/FruitSlicePageBackground';
import { FruitSliceViewerPage } from '../../../../fruit-slices/components/FruitSliceViewerPage';

export default function FruitSliceDetailPage() {
    const { id, frameId } = useLocalSearchParams<{
        id: string;
        frameId?: string;
    }>();

    return (
        <>
            <Stack.Screen options={{ title: 'Fruit Slice' }} />
            <FruitSlicePageBackground>
                <FruitSliceViewerPage sliceId={id} frameId={frameId} />
            </FruitSlicePageBackground>
        </>
    );
}
